module.exports = __webpack_public_path__ + "img/office.53274684.svg";